import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/core';
import React, { memo } from 'react';
import { useRequisitionDetails } from './hooks/useRequisitionDetails';
import { RequisitionDetailsContent } from './RequisitionDetailsContent';
import { NewRequisition, ShiftDetail } from './types/requistionDetails';
import { RequisitionDetailViewModel } from './utils/RequisitionDetailsViewModel';

export interface RequisitionDetailsViewProps {
  isOpen: boolean;
  onClose: () => void;
  requisition?: NewRequisition;
  shouldCompare?: boolean;
  candidateAvailabilities?: Record<string, ShiftDetail>;
  candidateNightAvailabilities?: Record<string, ShiftDetail>;
  isShiftIntersectable?: boolean;
}

export const RequisitionDetailsView = memo(
  ({
    isOpen,
    onClose,
    requisition,
    shouldCompare = false,
    candidateAvailabilities,
    candidateNightAvailabilities,
    isShiftIntersectable = false,
  }: RequisitionDetailsViewProps) => {
    const viewModel = useRequisitionDetails(
      requisition,
      shouldCompare,
      candidateAvailabilities,
      candidateNightAvailabilities,
      isShiftIntersectable,
    );
    return (
      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick size="4xl" scrollBehavior="inside" isCentered={false}>
        <ModalOverlay />
        <ModalContent borderRadius="8px" my={4} h="90vh" data-testid="requisition-details-modal">
          <ModalCloseButton data-testid="modal-close-button" />
          <ModalBody p={6} w="full">
            <RequisitionDetailsContent viewModel={viewModel as RequisitionDetailViewModel} />
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  },
);

RequisitionDetailsView.displayName = 'RequisitionDetailsView';
